export default __webpack_public_path__ + "static/media/security-icon2.3fd58127.svg";